module.exports = __webpack_public_path__ + "static/media/settings.99b77027.svg";